<!--<template>
  <div class="cm-container">
    <div class="grid">
      <div class="cm-card" :style="{backgroundImage: `url(${require('../../assets/gcla/certification.png')})`}">
        <div class="cm-details">
          <div class="bg-title mb-3 white-color" v-html="'Explore Our <br /> Certification'"></div>
          <router-link to="/" class="nl-btn" v-html="'Explore'"></router-link>
        </div>
        <div class="gradient-easing"></div>
      </div>
      <div class="cm-card" :style="{backgroundImage: `url(${require('../../assets/gcla/membership.png')})`}">
        <div class="cm-details">
          <div class="bg-title mb-3 white-color" v-html="'GCLA <br /> Membership'"></div>
          <router-link to="/" class="nl-btn" v-html="'Explore'"></router-link>
        </div>
        <div class="gradient-easing"></div>
      </div>

      <div class="cm-card" :style="{backgroundImage: `url(${require('../../assets/gcla/training-center.png')})`}">
        <div class="cm-widget" :style="{backgroundColor: `#806E5A88`}">
          <div class="title white-color" v-html="'Corporate Training'"></div>
          <div>
            <router-link to="/" class="nl-btn" v-html="'Explore'"></router-link>
          </div>
        </div>
      </div>
      
      <div class="cm-card cm-card-double">
        <div class="half-cm">
          <div class="cm-card-details" :style="{backgroundColor: '#001157'}">
            <div class="bg-title mb-3 white-color" v-html="'I Have <br /> Experience'"></div>
            <router-link to="/" class="nl-btn" v-html="'Read More'"></router-link>
          </div>
          <div class="cm-card-view" :style="{backgroundImage: `url(${require('../../assets/gcla/experience-2.png')})`}"></div>
        </div>

        <div class="half-cm">
          <div class="cm-card-view" :style="{backgroundImage: `url(${require('../../assets/gcla/experience-2.png')})`}"></div>
          <div class="cm-card-details" :style="{backgroundColor: '#600000'}">
            <div class="bg-title mb-3 white-color" v-html="'I Have <br /> Experience'"></div>
            <router-link to="/" class="nl-btn" v-html="'Read More'"></router-link>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>-->

<template>
  <div class="cm-container">

    <div class="grid">

      <div class="cm-card" :style="{backgroundImage: `url(${row.image4}) !important`}">
        <div class="cm-details">
          <div class="bg-title mb-3" v-html="row.title4"></div>
          <router-link v-if="row.redirect4" :to="row.redirect4" class="nl-btn" v-html="row.button4"></router-link>
        </div>
        <div class="gradient-easing"></div>
      </div>

      <div class="cm-card" :style="{backgroundImage: `url(${row.image5}) !important`}">
        <div class="cm-details">
          <div class="bg-title mb-3" v-html="row.title5"></div>
           <router-link v-if="row.redirect5" :to="row.redirect5" class="nl-btn" v-html="row.button5"></router-link>
        </div>
        <div class="gradient-easing"></div>
      </div>

      <div class="cm-card" :style="{backgroundImage: `url(${row.image6}) !important`}">
        <div class="cm-widget" :style="{backgroundColor: `${row.bgColor6} !important`}">
          <div class="title white-color" v-html="row.title6"></div>
          <div>
            <router-link v-if="row.redirect6" :to="row.redirect6" class="nl-btn" v-html="row.button6"></router-link>
          </div>
        </div>
      </div>
      
      <div class="cm-card cm-card-double">
        <div class="half-cm">
          <div class="cm-card-details" :style="{backgroundColor: `${row.bgColor7} !important`}">
            <div class="bg-title mb-3" v-html="row.title7"></div>
            <router-link v-if="row.redirect7" :to="row.redirect7" class="nl-btn" v-html="row.button7"></router-link>
          </div>
          <div class="cm-card-view" :style="{backgroundImage: `url(${row.image7}) !important`}"></div>
        </div>

        <div class="half-cm">
          <div class="cm-card-view" :style="{backgroundImage: `url(${row.image8}) !important`}"></div>
          <div class="cm-card-details" :style="{backgroundColor: `${row.bgColor8} !important`}">
            <div class="bg-title mb-3" v-html="row.title8"></div>
            <router-link v-if="row.redirect8" :to="row.redirect8" class="nl-btn" v-html="row.button8"></router-link>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<style scoped>
.cm-container {
  padding: 0.7rem
}
.grid {
  display: grid;
  grid-template-columns: repeat(2,minmax(0,1fr));
  grid-gap: 12.25rem;
  gap: 0.7rem;
  width: 100%;
}
.cm-card {
  position: relative;
  height: 470px;
  background-size: cover;
  background-position: top;
}
.cm-details {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 50px;
  z-index: 10;
}
.gradient-easing {
  height: 480px !important;
  position: absolute;
  width: 100%;
  background-image: linear-gradient(transparent,rgba(0,0,0,.00709) 10.47%,rgba(0,0,0,.02755) 19.56%,rgba(0,0,0,.06016) 27.58%,rgba(0,0,0,.1037) 34.81%,rgba(0,0,0,.15697) 41.57%,rgba(0,0,0,.21875) 48.13%,rgba(0,0,0,.28782) 54.79%,rgba(0,0,0,.36296) 61.85%,rgba(0,0,0,.44297) 69.61%,rgba(0,0,0,.52662) 78.36%,rgba(0,0,0,.6127) 88.39%,rgba(0,0,0,.7));
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 9;
}
.bg-title {
  font-size: 45px;
}
.title {
  line-height: 1;
  font-size: 35px;
}
.cm-widget {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 40px 30px;
  position: absolute;
  bottom: 0;
  width: 100%;
}
.cm-card-double {
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
}
.half-cm {
  height: calc(50% - 0.35rem);
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
}
.half-cm > div {
  width: 50%;
}
.cm-card-details {
  padding: 45px 35px
}

/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
  
}

@media (max-width: 767.98px) {
  .grid {
    grid-template-columns: repeat(1,minmax(0,1fr));
  }
  .cm-card {
    height: 304px;
  }
  .gradient-easing {
    height: 100% !important;
  }
  .cm-details {
    padding: 35px;
  }
  .cm-widget {
    padding: 27px 30px;
  }
  .cm-card-double {
    height: auto;
  }
  .half-cm {
    height: auto;
  }
  .half-cm > div {
    width: 100%;
  }
  .half-cm:first-of-type {
    margin-bottom: 0.7rem;
  }
  .cm-card-view {
    height: 250px;
    background-size: cover;
    order: 1;
  }
  .cm-card-details {
    order: 2;
    padding: 40px 30px;
  }
  .bg-title {
    font-size: 41px;
  }
}


/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {
  
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {
  .cm-card {
    height: auto;
  }
  .gradient-easing {
    height: 100% !important;
  }
  .cm-details {
    padding: 40px;
  }
  .bg-title {
    font-size: 41px;
  }
  .half-cm .cm-card-details {
    padding: 30px 25px;
  }
  .half-cm .bg-title {
    font-size: 30px;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {
  .cm-card-details {
    padding: 47px 25px;
  }
  .cm-card-details .bg-title {
    font-size: 40px;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {

}
</style>

<script>
export default {
  name: "Section3",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
    };
  },
  created() {
      //
  },
  methods: {
    //
  },
};
</script>
